jQuery(function ($) {
  $(document).ready(function () {
    //$('.tribe-tickets__rsvp-form-field-specialties').select2();
  })

  $(".register-button").on("click", function (event) {
    event.preventDefault()
    $("#rsvp-now").detach().insertAfter(".bottom-register-button")
    $(".register-button").hide()
    $("#rsvp-now").addClass("show-rsvp")
    setTimeout(function () {
      document.getElementById("rsvp-now").scrollIntoView({ behavior: "smooth", block: "center" })
    }, 100)
  })
  $(".tribe-filter-bar-c-filter__toggle").on("click", function (event) {
    let info = $(event.target).closest(".tribe-filter-bar-c-filter").find(".tribe-filter-bar-c-filter__container")
    $(".tribe-filter-bar-c-filter__container").each(function () {
      if ($(this).attr("style") == "display: block;" && this != info.get(0)) {
        $(this).hide()
      }
    })
  })
  $("body").on("submit", 'form[name="tribe-tickets-rsvp-form"]', function (event) {
    console.log("submit")
    console.log($("input[type='radio'][name='events_signup']:checked").val())
    if ($("input[type='radio'][name='events_signup']:checked").val() === "true") {
      var WpJsonUrl = document.querySelector('link[rel="https://api.w.org/"]').href
      var homeUrl = WpJsonUrl.replace("/wp-json/", "")
      localStorage.removeItem("redirectToRegister")
      console.log("redirect")
      setTimeout(() => {
        window.location = `${homeUrl}/registration`
      }, 2000)
    }
  })
})
jQuery(".tribe-events-gcal").attr("target", "_blank")
